export default __webpack_public_path__ + "static/media/3.9ed7dddc.png";